import React, {useEffect, useState} from 'react'
import {Checkbox, Modal} from 'antd'
import {useIntl} from 'react-intl'

export type ConfirmWithCheckModalProps = {
  onOk: (isChecked: boolean, isChecked2?: boolean) => void
  isOpen: boolean
  onCancel: () => void
  label: string
  checkboxLabel: string
  defaultChecked?: boolean
  checkboxLabelSecondСondition?: string
}

export function ConfirmWithCheckModal(props: ConfirmWithCheckModalProps) {
  const [isChecked, setIsChecked] = useState(Boolean(props.defaultChecked))
  const [isCheckedSecondСondition, setIsCheckedSecondСondition] = useState(false)
  const intl = useIntl()

  useEffect(() => {
    if (props.isOpen) {
      setIsChecked(Boolean(props.defaultChecked))
    }
  }, [props.isOpen])

  return (
    <Modal
      destroyOnHidden
      width={500}
      onOk={() => props.onOk(isChecked, isCheckedSecondСondition)}
      open={props.isOpen}
      onCancel={props.onCancel}
    >
      <div>{props.label}</div>
      <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
        {props.checkboxLabel}
      </Checkbox>
      {props.checkboxLabelSecondСondition && (
        <Checkbox
          disabled={!isChecked}
          checked={isChecked ? isCheckedSecondСondition : isChecked}
          onChange={(e) => setIsCheckedSecondСondition(e.target.checked)}
        >
          {props.checkboxLabelSecondСondition}
        </Checkbox>
      )}
    </Modal>
  )
}
